import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import shopStore from '../../stores/shopStore';
import membershipStore from '../../stores/membershipStore';

class CardTypeLogos extends Component {

	render() {
		let { method } = this.props;
		if (!method) {
			method = shopStore.billingInfo.get('paymentmethod');		
		}
		const baseUrl = 'https://my.kabbalah.com/ticket-widget/media/';
		const width = '45px';
		let displayAmex = true;
		if (membershipStore.defactoCurrency && membershipStore.defactoCurrency.code &&
				membershipStore.defactoCurrency.code !== 'USD') {
			displayAmex = false;							
		}
		return (
			<span>
				<img 
					src={baseUrl + 'visa-logo.png'} 
					alt='' 
					width={width} 
					className={method === 5 ? 'tkc-border-red' : 'border'} 
				/>
				<img 
					src={baseUrl + 'mastercard-logo.png'} 
					alt='' 
					width={width} 
					className={method === 4 ? 'tkc-border-red' : 'border'} 
				/>
				{displayAmex &&
				<img 
					src={baseUrl + 'amex-logo.png'} 
					alt='' 
					width={width} 
					className={method === 6 ? 'tkc-border-red' : 'border'} 
				/>	
				}
				<img 
					src={baseUrl + 'discover-logo.png'} 
					alt='' 
					width={width} 
					className={method === 3 ? 'tkc-border-red' : 'border'} 
				/>										
			</span>
		);
	}
}

export default observer(CardTypeLogos);



// WEBPACK FOOTER //
// ./src/components/billing-form/CardTypeLogos.js